module.exports = __webpack_public_path__ + "zmenseni-prsou_1_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zmenseni-prsou_1_after_tn.jpg
// module id = 1745
// module chunks = 0